var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleSlide)?_c('div',{staticClass:"wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{attrs:{"id":"nc"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }